module.exports = __webpack_public_path__ + "01_short_gold.ce92ec78.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/01_short_gold.png
// module id = tooc
// module chunks = 0